import {ActionType} from 'Interfaces'
import * as type from '../types'

export const cleanSnackbars = (): ActionType<undefined> => {
  return {
    type: type.app.snackbar.clean,
  }
}
